export const FETCH_MATERIALS_DATA = "FETCH_MATERIALS_DATA";
export const FETCH_MATERIALS_SUCCESS = "FETCH_MATERIALS_SUCCESS";
export const FETCH_MATERIALS_FAILURE = "FETCH_MATERIALS_FAILURE";

export const FETCH_MATERIALS_EDIT_DATA = "FETCH_MATERIALS_EDIT_DATA";
export const FETCH_MATERIALS_EDIT_SUCCESS = "FETCH_MATERIALS_EDIT_SUCCESS";
export const FETCH_MATERIALS_EDIT_FAILURE = "FETCH_MATERIALS_EDIT_FAILURE";